module.exports = __webpack_public_path__ + "static/media/black-visa.3d349034.svg";